module.exports = __webpack_public_path__ + "media/sod-large.e1fd1d17.mp4";